function bikeTypeSupportsFitting(mtbType) {
    let notSupportingTypes = ["Dirtbike", "Downhill", "Enduro", "Timetrial"];
    return notSupportingTypes.filter(x => x === mtbType).length === 0;
}

export default bikeTypeSupportsFitting;